import { useEffect } from "react";
import { useSelector, shallowEqual } from "react-redux";

export default function useIsNoIframe() {
  const { link, locale } = useSelector(
    (state) => ({
      link: state.getQrLinkSlice.link,
      locale: state.changeLang.change,
    }),
    shallowEqual
  );
  const isNoIframe =
    window.location.href.slice(
      window.location.href.lastIndexOf("/") + 1,
      window.location.href.length
    ) !== "iframe";

  useEffect(() => {
    if (!isNoIframe) {
      document
        .querySelector("body")
        .style.setProperty("background-color", "transparent", "important");
    }
  }, []);

  const goToLink = (newLink = null) => {
    const linkValue = newLink ? newLink : link;
    window.top.location.href = `${window.location.origin}${
      locale === "en" ? "" : `/${locale}`
    }/qr-code-generator/qr?url=${linkValue}`;
  };

  return {
    isNoIframe,
    goToLink,
  };
}
